var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-circle"}),(_vm.loadingText)?_c('p',{staticClass:"loader-text"},[_vm._v(_vm._s(_vm.loadingText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }